module.exports = __webpack_public_path__ + "media/images/icons/rooms/bath-26cb1a0f8ed496e9697749b8bbab573e.svg";